/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SmsAutoDisableStatus } from './SmsAutoDisableStatus';
import {
    SmsAutoDisableStatusFromJSON,
    SmsAutoDisableStatusFromJSONTyped,
    SmsAutoDisableStatusToJSON,
    SmsAutoDisableStatusToJSONTyped,
} from './SmsAutoDisableStatus';

/**
 * 
 * @export
 * @interface FindSmsDeliveryStatus200Response
 */
export interface FindSmsDeliveryStatus200Response {
    /**
     * 
     */
    data?: SmsAutoDisableStatus | null;
}

/**
 * Check if a given object implements the FindSmsDeliveryStatus200Response interface.
 */
export function instanceOfFindSmsDeliveryStatus200Response(value: object): value is FindSmsDeliveryStatus200Response {
    return true;
}

export function FindSmsDeliveryStatus200ResponseFromJSON(json: any): FindSmsDeliveryStatus200Response {
    return FindSmsDeliveryStatus200ResponseFromJSONTyped(json, false);
}

export function FindSmsDeliveryStatus200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindSmsDeliveryStatus200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] === undefined ? undefined : json['data'] === null ? null : SmsAutoDisableStatusFromJSON(json['data']),
    };
}

export function FindSmsDeliveryStatus200ResponseToJSON(json: any): FindSmsDeliveryStatus200Response {
    return FindSmsDeliveryStatus200ResponseToJSONTyped(json, false);
}

export function FindSmsDeliveryStatus200ResponseToJSONTyped(value?: FindSmsDeliveryStatus200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SmsAutoDisableStatusToJSON(value['data']),
    };
}

